var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photograph_box"},[_c('banner-carousel'),_c('div',{staticClass:"photograph_list_box"},[_c('div',{staticClass:"container"},[_c('photograph-phototheme')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }